import Checkbox2 from './component'

export default Checkbox2
